import { Component, EventEmitter } from '@angular/core';
import { CHANGE_PAYMENT_METHOD_URL } from '@rci/self-serve-fido/app.constant';
import { ModalInjectableData } from '@rogers/cdk/common/classes';
import { AutopayDiscountRow, AutopayDiscountTableComponent } from '@rogers/self-serve-payments';
import { ModalModule } from '@rogers/cdk/modal';
import { TranslatePipe } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { ButtonComponent } from '@rogers/cdk/button';

@Component({
  selector: 'fss-autopay-discount-table-modal',
  templateUrl: './autopay-discount-table-modal.component.html',
  standalone: true,
  imports: [ModalModule, TranslatePipe, AutopayDiscountTableComponent, RouterLink, ButtonComponent],
})
export class AutopayDiscountTableModalComponent {
  emitUserAction: EventEmitter<string> = new EventEmitter<string>();
  discountRows: AutopayDiscountRow[];
  hasRogersMastercard = false;
  headingKey = 'overview.autopay-promo.discount-table-modal.heading-no-rmc';

  // eslint-disable-next-line @angular-eslint/prefer-inject
  constructor(private readonly modalData: ModalInjectableData) {
    this.discountRows = this.modalData.source.discountRows ?? [];
    this.hasRogersMastercard = !!this.modalData.source.hasRogersMastercard;
    this.headingKey = this.hasRogersMastercard
      ? 'overview.autopay-promo.discount-table-modal.heading-has-rmc'
      : 'overview.autopay-promo.discount-table-modal.heading-no-rmc';
  }

  close(action = '') {
    this.emitUserAction.emit(action);
  }

  protected readonly CHANGE_PAYMENT_METHOD_URL = CHANGE_PAYMENT_METHOD_URL;
}
